export default __webpack_public_path__ + "static/media/logo-filled.44bc60d2.svg";